type ActionFn = (e: Event) => unknown;

export default function disableBubbling(action?: ActionFn) {
  return function (event: Event): unknown {
    event.stopPropagation();

    if (action) {
      return action(event);
    }
    return null;
  };
}
